"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _default = function _default(_ref) {
  var groups = _ref.groups;
  return groups.map(function (tzg) {
    return {
      text: tzg.groupName,
      value: tzg.groupName,
      options: tzg.timezones.sort(function (x, y) {
        return parseInt(x.offset, 10) - parseInt(y.offset, 10);
      }).map(function (tz) {
        return {
          text: _I18n.default.text('timezone_utils.utc_plus_minus', {
            offset: tz.offset,
            timezone: _I18n.default.SafeString(tz.name)
          }),
          value: tz.identifier()
        };
      }).toJS()
    };
  }).sort(function (x, y) {
    var mainCountries = ['US', 'Europe', 'Canada'];

    for (var i in mainCountries) {
      if (x.text === mainCountries[i]) {
        return -1;
      }

      if (y.text === mainCountries[i]) {
        return 1;
      }
    }
  }).toArray();
};

exports.default = _default;
module.exports = exports.default;